





















import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';

export default defineComponent({
  name: 'BaseCircleIcon',
  inject: {
    components: {
      default: {
        BaseButton,
        BaseIcon,
      },
    },
  },
  props: {
    icon: {
      type: [String, Array],
      default: 'home',
    },
    iconSize: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: 'button-icon',
    },
  },
  data(...args): any {
    return args;
  },
});
